import React, { Component } from 'react'
import { withLastLocation } from 'react-router-last-location-17'
import { History } from 'history'

import { request } from '../../../helpers/apiHelper'
import { signLoanAgreement } from '../queries'
import { displayNotification } from '../../../actions/notificationsActions'
import { Task } from '../types'

export interface Props {
  url: string
  lastLocation: Location
  task: Task
  history: History
}

export class SignLoanAgreement extends Component<Props> {
  fetchSignLoanAgreement = (returnUrl, loanId) => {
    return request(signLoanAgreement.default, {
      returnTo: returnUrl,
      id: loanId,
    })
      .then((response) => {
        window.location.replace(
          response.data.data.task.verifiables[0].signingUrl
        )
      })
      .catch((error) => {
        displayNotification(`Failed to redirect : ${error}`, '5000')
        throw new Error(error)
      })
  }

  backToIndex = () => {
    this.props.history.goBack()
  }

  render() {
    if (!this.props.lastLocation) return null
    const win = window.location.host
    const returnUrl = `https://${win}${this.props.lastLocation.pathname}`
    const loanId = this.props.task
    return (
      <div className="task-bodies__col2--mg-top-1">
        <div className="task-bodies__info-header">
          <div className="task-bodies__info-header__row">
            <button
              className="task-bodies__button"
              onClick={() => this.fetchSignLoanAgreement(returnUrl, loanId)}
            >
              Verify the signature on Docusign
            </button>
          </div>
        </div>
        <button
          type="button"
          onClick={this.backToIndex}
          data-testid="cancelTaskButton"
          className="button button--link-text task-bodies__cancel-button"
        >
          Cancel
        </button>
      </div>
    )
  }
}

export default withLastLocation(SignLoanAgreement)
